// StatusBadge.jsx
// PO status badge component

import React from 'react';

const STATUS_COLORS = {
    draft: { bg: '#f3f4f6', text: '#374151' },
    submitted: { bg: '#dbeafe', text: '#1e40af' },
    partial: { bg: '#fef3c7', text: '#92400e' },
    received: { bg: '#dcfce7', text: '#166534' },
    cancelled: { bg: '#fecaca', text: '#991b1b' }
};

const STATUS_LABELS = {
    draft: 'Draft',
    submitted: 'Submitted',
    partial: 'Partial',
    received: 'Received',
    cancelled: 'Voided'
};

const StatusBadge = ({ status }) => {
    const colors = STATUS_COLORS[status] || STATUS_COLORS.draft;
    const label = STATUS_LABELS[status] || status;
    return (
        <span style={{
            display: 'inline-block',
            padding: '3px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: 500,
            backgroundColor: colors.bg,
            color: colors.text
        }}>
            {label}
        </span>
    );
};

export default StatusBadge;
